<template>
	<div class="template tips"  v-show="dataVal.IsShow || dataVal.IsShow == null">
		<div class="panel_wrap">
			<div class="panel_tips" v-for='(item,index) in dataVal.Property.Placeholder' :key='index' style="color: red;" >{{item.Text}}</div>
		</div>
	</div>
</template>

<script>
	export default{
		props: ['dataVal'],
		data(){
			return{
				
			}
		},
		created() {
		},
	}
</script>

<style>
	@import '../assets/css/common.css';
</style>
